import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { User } from '../../services/entities/impl/blfApi/schemas/user';

/**
 * Initialize Sentry with user information.
 * @param user Object containing user information.
 * @param isAuthenticated A boolean indicating if the user is authenticated.
 */
export const useInitSentry = (user?: User | null) => {
  // Set user name and email
  useEffect(() => {
    if (user?.email) {
      console.log(
        'Sentry setUser: ',
        user.email,
        user.firstName,
        user.lastName
      );
      Sentry.setUser({
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
      });
    }
  }, [user?.email, user?.firstName, user?.lastName]);
};
